import { presentNativeAppUpdateUi } from '@/utils/appUpdate';
import { isAimetaAndroidWebView } from '@/utils/platform';

let checkedOnce = false;

/** 登录后或 App 启动时检查更新（Android 原生弹层） */
export async function runAppUpdateCheck(force = false): Promise<boolean> {
  if (!isAimetaAndroidWebView()) return false;
  if (checkedOnce && !force) return false;
  checkedOnce = true;
  return presentNativeAppUpdateUi('startup');
}

export function useAppUpdateDialogState() {
  return {
    runAppUpdateCheck,
  };
}
